__turbopack_context__.v({
  "blockGlobal": "BlockGlobal-module-scss-module__v8VY0W__blockGlobal",
});
